export const expiración = {
	nombre: "Expiración",
	dia: "Viernes Santo",
	nombrecompleto:
		"Muy Ilustre y Venerable Cofradía del Santísimo Cristo de la Expiración y María Santísima de la Victoria",
	sede: "Iglesia de Santa Catalina",
	pasos: 2,
	distancia: [1330, 2460],
	penitentes: 190,
	cargadores: 126,
	web: "http://www.diariodecadiz.es/semana_santa/Expiracion_0_1229577735.html",

	ida: [
		{ lng: -6.30175, lat: 36.52822 },
		{ lng: -6.3017106, lat: 36.5281171 },
		{ lng: -6.3002247, lat: 36.5285568 },
		{ lng: -6.3000342, lat: 36.5285837 },
		{ lng: -6.2990405, lat: 36.5287033 },
		{ lng: -6.2989815, lat: 36.5287206 },
		{ lng: -6.2981486, lat: 36.5288326 },
		{ lng: -6.2977289, lat: 36.528948 },
		{ lng: -6.297458, lat: 36.5289695 },
		{ lng: -6.2968437, lat: 36.5289393 },
		{ lng: -6.2958902, lat: 36.5286333 },
		{ lng: -6.2948985, lat: 36.5281802 },
		{ lng: -6.2941639, lat: 36.5279929 },
		{ lng: -6.2932615, lat: 36.5277856 },
		{ lng: -6.2928961, lat: 36.5285241 },
		{ lng: -6.2925183, lat: 36.5295578 },
		{ lng: -6.2927927, lat: 36.5297648 },
		{ lng: -6.2931841, lat: 36.529754 },
		{ lng: -6.2935648, lat: 36.5297077 },
		{ lng: -6.2945169, lat: 36.5296355 },
		{ lng: -6.2946095, lat: 36.5295541 },
		{ lng: -6.2950755, lat: 36.5296196 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957025, lat: 36.5290956 },
		{ lng: -6.2954168, lat: 36.5297648 },
		{ lng: -6.2956622, lat: 36.5299588 },
		{ lng: -6.295276, lat: 36.5303575 },
		{ lng: -6.2950212, lat: 36.5308349 },
		{ lng: -6.2949246, lat: 36.5308392 },
		{ lng: -6.29493, lat: 36.5314588 },
		{ lng: -6.2964508, lat: 36.5317735 },
		{ lng: -6.2964012, lat: 36.5318349 },
		{ lng: -6.2967901, lat: 36.5325408 },
		{ lng: -6.2964253, lat: 36.5329212 },
		{ lng: -6.2962711, lat: 36.533238 },
		{ lng: -6.2963288, lat: 36.5332897 },
		{ lng: -6.2962697, lat: 36.533933 },
		{ lng: -6.2960149, lat: 36.5339718 },
		{ lng: -6.2954517, lat: 36.5340181 },
		{ lng: -6.2922256, lat: 36.5302901 },
		{ lng: -6.2927624, lat: 36.5297957 },
		{ lng: -6.2924769, lat: 36.529568 },
		{ lng: -6.2928613, lat: 36.5285133 },
		{ lng: -6.2932519, lat: 36.5277424 },
		{ lng: -6.2949318, lat: 36.5281382 },
		{ lng: -6.2959032, lat: 36.5285883 },
		{ lng: -6.2968342, lat: 36.5288737 },
		{ lng: -6.2974418, lat: 36.528913 },
		{ lng: -6.2977054, lat: 36.5289089 },
		{ lng: -6.2981228, lat: 36.5287948 },
		{ lng: -6.2989297, lat: 36.5286849 },
		{ lng: -6.2990005, lat: 36.5286645 },
		{ lng: -6.300196, lat: 36.5285217 },
		{ lng: -6.3017379, lat: 36.528072 },
		{ lng: -6.3017991, lat: 36.5282151 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-30T18:15",
			latlng: [36.52821, -6.30174]
		},
		{
			name: "Nueva",
			hora: "2018-03-30T20:10",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-30T21:10",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-30T22:10",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-30T22:40",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T22:50",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Santa Maria",
			"Campo del Sur",
			"San Juan de Dios",
			"Plaza San Juan de Dios",
			"Avda. 4 de Diciembre de 1977",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cadiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Plaza San Juan de Dios (centro)",
			"San Juan de Dios",
			"Campo del Sur",
			"Santa Maria"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/expiración.js